const nonSpecPain=[
    {
    label:"Site(s)",
    controlType:"text",
    options:[]
    },

    {
    label:"Severity",
    controlType:"radio button",
    options:["Mild", "Moderate", "Severe"]   
    },

    {
    label:"Character",
    controlType:"radio button",
    options:["Dull", "Sharp", "Crampy"]   
    },

    {
    label:"When present",
    controlType:"radio button",
    options:["Constant","Intermittent"]
    },

{
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Occasionally"]
    },
    

    { label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default nonSpecPain